import React from 'react';
import { Grid, Modal } from 'semantic-ui-react';

import ErrorAlert from 'components/ErrorAlert';
import QueryStringButton from 'components/QueryStringButton';
import RoleModal from 'components/RoleModal';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import SubmittingButton from 'components/SubmittingButton';
import { connect } from 'react-redux';
import { requestUnapproveTimesheet } from 'services/timesheets/actions';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

export const TIMESHEET_UNAPPROVE_MODAL = 'timesheetUnapproveModal';

interface ConnectedProps {
    timesheetId: number;
}

interface DispatchProps {
    requestUnapproveTimesheet: typeof requestUnapproveTimesheet;
}

type Props = ConnectedProps & DispatchProps;

export class TimesheetUnapproveModalComponent extends React.PureComponent<Props> {
    handleSubmit(): void {
        const { timesheetId, ...props } = this.props;

        props.requestUnapproveTimesheet(timesheetId);
    }

    render(): React.ReactElement {
        return (
            <RoleModal
                param={TIMESHEET_UNAPPROVE_MODAL}
                requiredRoles={[ADMIN, MANAGER]}
                namespace="TimesheetUnapproveModal"
                ignoreSeason
            >
                <React.Fragment>
                    <Modal.Header>Unapprove Timesheet</Modal.Header>
                    <Modal.Content>
                        <ErrorAlert namespace="TIMESHEET_UNAPPROVE" />
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <QueryStringButton
                                    params={{
                                        [TIMESHEET_UNAPPROVE_MODAL]: undefined,
                                        selectedTimesheet: undefined
                                    }}
                                    buttonProps={{
                                        type: 'button',
                                        fluid: true,
                                        basic: true,
                                        primary: true
                                    }}
                                >
                                    Cancel
                                </QueryStringButton>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <SubmittingButton
                                    type="submit"
                                    namespace="TIMESHEET_UNAPPROVE"
                                    primary
                                    fluid
                                    negative
                                    onClick={(): void => this.handleSubmit()}
                                >
                                    Unapprove
                                </SubmittingButton>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </React.Fragment>
            </RoleModal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    timesheetId: makeSelectQueryStringNumberValue('selectedTimesheet')
});

export default connect(mapStateToProps, {
    requestUnapproveTimesheet
})(TimesheetUnapproveModalComponent);
